import { render, staticRenderFns } from "./TskcIndex.vue?vue&type=template&id=62cfd478&scoped=true&"
import script from "./TskcIndex.vue?vue&type=script&lang=js&"
export * from "./TskcIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cfd478",
  null
  
)

export default component.exports